import React from 'react';

const InvoiceExporterSection = ({ 
    updatedClient, 
    data, 
    toggleExporterOption, 
    changeExporterValues, 
    changeColAmountExporter, 
    getInvoiceExporterOption, 
    getColumnValueExporter, 
    getHardCodedValueExporter, 
    changeColumnValueExporter 
}) => {
    return (
        <div className='mb-2'>
            {/* Invoice Exporter Settings */}
            <div className='row mt-2'>
                <div
                    className='col-2'>{data.t.read("client_table.invoice_export")}</div>
                <div className='col-10'>
                    <div className='row'>
                        <div className='col-12'>
                            <div key={"export_format"} className='row mt-1'>
                                <div className='col-5'>
                                    {data.t.read("client.csv_exporter.export_format")}
                                </div>
                                <div className='col-4'>
                                    <select
                                        value={updatedClient.config?.invoice_exporter?.export_format || ""}
                                        onChange={(e) => changeExporterValues("export_format", e)}
                                        name={"export_format"}>
                                        <option value=""></option>
                                        {
                                            ["elite", "elite_xml", "aderant", "juris_format", "juris_lexis_nexis", "sage300", "surepoint"].map(option => (
                                                <option key={option} value={option}>
                                                    {data.t.read("client.csv_exporter.export_format_options." + option)}
                                                </option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div>
                            {updatedClient.config?.invoice_exporter?.export_format === "juris_format" && (
                                <div key={"use_gl_description_for_distribution_postings"} className='row mt-1'>
                                    <div className='col-5'>
                                        {data.t.read("client.csv_exporter.use_gl_description_for_distribution_postings")}
                                    </div>
                                    <div className='col-4'>
                                        <input type="checkbox"
                                            checked={getInvoiceExporterOption("use_gl_description_for_distribution_postings")}
                                            onChange={() => toggleExporterOption("use_gl_description_for_distribution_postings")}
                                            name={"use_gl_description_for_distribution_postings"} />
                                    </div>
                                </div>
                            )}
                            <hr />
                            {
                                ["export_supplier", "detail_on_multiple_line", "re_export_supplier"].map(option => {
                                    return (
                                        <div key={option} className='row mt-1'>
                                            <div className='col-5'>
                                                {data.t.read("client.csv_exporter." + option)}
                                            </div>
                                            <div className='col-4'>
                                                <input type="checkbox"
                                                    checked={getInvoiceExporterOption(option)}
                                                    onChange={() => toggleExporterOption(option)}
                                                    name={option} />
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            <hr />
                            <div key={"separator_csv"} className='row mt-2'>
                                <div className='col-5'>
                                    {data.t.read("client.csv_exporter.separator")}
                                </div>
                                <div className='col-7'>
                                    <input type="text"
                                        value={updatedClient.config?.invoice_exporter["separator"] || ""}
                                        onChange={(e) => changeExporterValues("separator", e)}
                                        name={"separator"} placeholder="" />
                                </div>
                            </div>
                            <div key={"decimal_separator_csv"} className='row mt-2'>
                                <div className='col-5'>
                                    {data.t.read("client.csv_exporter.decimal_separator")}
                                </div>
                                <div className='col-7'>
                                    <input type="text"
                                        value={updatedClient.config?.invoice_exporter["decimal_separator"] || ""}
                                        onChange={(e) => changeExporterValues("decimal_separator", e)}
                                        name={"decimal_separator"}
                                        placeholder="" />
                                </div>
                            </div>
                            <hr />
                            <div key={"unit_exporter"} className='row mt-1'>
                                <div className='col-5'>
                                    {data.t.read("client.csv_exporter.group_invoice_by")}
                                </div>
                                <div className='col-4'>
                                    <select
                                        value={updatedClient.config?.invoice_exporter.group_invoice_by || ""}
                                        onChange={(e) => changeExporterValues("group_invoice_by", e)}>
                                        {
                                            ["", "unit"].map(option => {
                                                return (
                                                    <option key={option}
                                                        value={option}>{option !== "" ? data.t.read("client.csv_exporter.group_options." + option) : ""}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div key={"details_column_amount"} className='row mt-2'>
                                <div className='col-5'>
                                    {data.t.read("client.csv_exporter.details_column_amount")}
                                </div>
                                <div className='col-7'>
                                    <input type="number"
                                        value={updatedClient.config?.invoice_exporter["details_column_amount"] || 0}
                                        onChange={(e) => changeExporterValues("details_column_amount", e)}
                                        name={"details_column_amount"} min="0" />
                                </div>
                            </div>
                            <div key={"column_amount"} className='row mt-2'>
                                <div className='col-5'>
                                    {data.t.read("client.csv_exporter.column_amount")}
                                </div>
                                <div className='col-7'>
                                    <input type="number"
                                        value={updatedClient.config?.invoice_exporter["column_amount"] || 0}
                                        onChange={changeColAmountExporter}
                                        name={"column_amount"} min="0" />
                                </div>
                            </div>
                            <div key={"taxes_gl"} className='row mt-2'>
                                <div className='col-5'>
                                    {data.t.read("client.csv_exporter.taxes_gl")}
                                </div>
                                <div className='col-7'>
                                    <input type="text"
                                        value={updatedClient.config?.invoice_exporter["taxes_gl"] || ""}
                                        onChange={(e) => changeExporterValues("taxes_gl", e)}
                                        name={"taxes_gl"}
                                        placeholder="Example 2103,2104" />
                                </div>
                            </div>
                            <div className='row mt-1'>
                                {
                                    Array.from({ length: updatedClient.config?.invoice_exporter.column_amount || 0 }).map((_, n) => {
                                        return (
                                            <div className='col-4 mt-3'
                                                key={"column-" + n}>
                                                <label
                                                    htmlFor={"column-" + n}>{"Column #" + (n + 1)}</label><br />
                                                <select name={"column-" + n}
                                                    value={getColumnValueExporter(n)}
                                                    onChange={(e) => changeColumnValueExporter(e.target.value, n)}>
                                                    <option key={"no_data"}
                                                        value={""}></option>
                                                    <option key={"hard_coded"}
                                                        value={"HardCoded"}>HardCoded
                                                    </option>
                                                    <optgroup label="Invoice">
                                                        {
                                                            [
                                                                "supplier_name",
                                                                "supplier_number",
                                                                "location",
                                                                "invoice_number",
                                                                "invoice_date",
                                                                "invoice_due_date",
                                                                "invoice_total",
                                                                "comments"
                                                            ].map(option => {
                                                                return (
                                                                    <option
                                                                        key={option}
                                                                        value={option}>{option !== "" ? data.t.read("client.csv_exporter.options." + option) : ""}</option>
                                                                );
                                                            })
                                                        }
                                                    </optgroup>
                                                    <optgroup label="Details">
                                                        {
                                                            [
                                                                "detail_gl_code",
                                                                "detail_description",
                                                                "detail_qty",
                                                                "detail_unit_price",
                                                                "detail_total",
                                                                "detail_work_date",
                                                                "detail_location"
                                                            ].map(option => {
                                                                return (
                                                                    <option
                                                                        key={option}
                                                                        value={option}>{option !== "" ? data.t.read("client.csv_exporter.options." + option) : ""}</option>
                                                                );
                                                            })
                                                        }
                                                    </optgroup>
                                                </select>
                                                {
                                                    getColumnValueExporter(n) === "HardCoded" ?
                                                        <input className='mt-1'
                                                            type="text"
                                                            value={getHardCodedValueExporter(n)}
                                                            onChange={(e) => changeColumnValueExporter("HardCoded:" + e.target.value, n)}
                                                            name={"HardCoded:" + n} />
                                                        :
                                                        null
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceExporterSection;
